import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Product } from '../../../../models/product';

@Component({
    selector: 'lib-whiteboard-product-list-view',
    templateUrl: './whiteboard-product-list-view.component.html',
    styleUrls: ['./whiteboard-product-list-view.component.css'],
    standalone: false
})
export class WhiteboardProductListViewComponent extends ListItemRendererComponent<Product[]> implements OnInit, AfterViewInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
